import featureProdSlider from '../components/feature-prod-slider'

export default {
	namespace: 'home',
	beforeEnter() {

	},
	afterEnter(barba) {
		console.log('View: home')
		// featureProdSlider(barba)
	},
	beforeLeave() {

	},
	afterLeave() {

	}
}
